export const version = '250722'; //YYMMDD 
